export default __webpack_public_path__ + "static/IMG_8966-0aeea4dc2e214da071d65b55d9f6e61e.png";